<template>
    <div 
      class="switch" 
    >
      <img 
        width="25"
        height="25"
        :src="UserRoleSelected" 
        draggable="false"
      />
    </div>
  </template>

<script setup>
import UserRoleSelected from '@/assets/images/icons/user-role-selected.svg';

</script>

<style scoped>
    .switch{
        user-select: none;
    }
</style>